import { createContext, useContext } from 'react';

/**
 * Lets a host (e.g. the POS menu item editor) override how the shared inventory
 * hooks refetch the owning entity after a mutation. When no provider is present
 * the hooks fall back to their default behavior (regular menu product fetch),
 * so existing usage is unaffected.
 *
 * Shape:
 *   {
 *     // Returns the fresh entity (must expose `_id`, `inventory[]`, `useInventory`).
 *     refetchProduct?: (entityId: string) => Promise<object>,
 *   }
 */
const InventoryConfigContext = createContext(null);

export const InventoryConfigProvider = InventoryConfigContext.Provider;

export const useInventoryConfig = () => useContext(InventoryConfigContext);

export default InventoryConfigContext;
